// extracted by mini-css-extract-plugin
export default {"warehouse":"WarehouseMap_warehouse__7Tq3B","checked":"WarehouseMap_checked__WJoz0","nospace":"WarehouseMap_nospace__Mtm73","shelfLabel":"WarehouseMap_shelfLabel__mf1W0"};